import { css } from 'styled-components';

function getRadius(radius?: string | number) {
    if (radius === undefined || radius === '' || Number(radius) < 1) {
        return undefined;
    }

    if (typeof radius === 'string') return radius;

    return `${radius}px`;
}

export function thumbnailOverflowWrapper(radius?: string | number) {
    // The `z-index` value is required in order to force
    // the nested <Thumbnail /> styles to be masked by
    // the radius + overflow.
    return css`
        position: relative;
        z-index: 1;
        overflow: hidden;
        border-radius: ${getRadius(radius)};
    `;
}
